import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={16}
            viewBox="0 0 24 16"
            fill="none"
        >
            <path
                d="M0 16v-2.667h24V16H0zm0-6.667V6.667h24v2.666H0zm0-6.666V0h24v2.667H0z"
                fill="#00A8FF"
            />
        </svg>
    );
};

export default React.memo(Menu);
